<template>
    <div class="login default-theme"
        :style="{ backgroundImage: 'url(' + lambda.bg + ')', backgroundSize: 'cover', backgroundPosition: 'center top' }">
        <div class="login-layer"></div>
        <div class="wrap">
            <div class="content">
                <div class="content-blur"></div>
                <div class="content-color-layer"></div>
                <div id="slideshow">
                    <div class="one">
                        <h2>
<!--                            mubis-->
                            <img src="/assets/app/images/logo-horz-msue.png" />
<!--                            iumc-->
<!--                            <img src="/assets/app/images/logo-horz.png" />-->
                            <span>СУРГАЛТЫН УДИРДЛАГА МЕНЕЖМЕНТИЙН ЦАХИМ СИСТЕМ</span>
                        </h2>
                        <p>
                            University Learning Management
                        </p>
                    </div>
                </div>
            </div>
            <div class="auth">
                <div class="auth-blur"></div>
                <div class="auth-color-layer"></div>
<!--                <div class="lang-switcher" v-if="lambda.has_language && languages.length >= 2">-->
<!--                    <a v-for="item in languages" :key="item.index" :class="selectedLang == item.code ? 'active' : ''"-->
<!--                        href="javascript:void(0)" @click="switchLanguage(item.code)">-->
<!--                        <img :src="`/images/flags/${item.code}.png`" alt="">-->
<!--                        {{ item.label }}-->
<!--                    </a>-->
<!--                </div>-->
                <router-view :selectedLang="selectedLang">
                    <div class="copyright" style="width:70%; text-align:center;" slot="copyright">
                        Copyright &copy; {{ new Date().getFullYear() }} University Learning Management
                    </div>
                </router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { loadLanguageAsync } from "../app/locale";
export default {
    name: "default",
    data() {
        return {
            loading: false,
            isSuccess: false,
            isError: false,
            credentials: {
                login: null,
                password: null
            },
            selectedLang: localStorage.getItem("lang") == null ? window.lambda.default_language : localStorage.getItem("lang"),
            languages: window.lambda.languages,
            copyright: window.lambda.copyright,
            lambda: window.lambda,
        }
    },

    beforeMount() {
        if (this.selectedLang === "mn_MN" || this.selectedLang === "en_US") {
            loadLanguageAsync(this.selectedLang);
        } else {
            loadLanguageAsync("mn_MN");
        }
    },

    computed: {
        lang() {
            const labels = ['title', 'subtitle'];
            return labels.reduce((obj, key, i) => {
                obj[key] = this.$t('user.' + labels[i]);
                return obj;
            }, {});
        }
    },

    methods: {
        switchLanguage(val) {
            this.selectedLang = val;
            // loadLanguageAsync(val);
        },
    }
}
</script>

<style lang="scss">
@import "./style";
</style>
